import { render } from "./Shift.vue?vue&type=template&id=4fbb3cdd"
import script from "./Shift.vue?vue&type=script&lang=js"
export * from "./Shift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__